/**
 * Point d'entrée principal pour le package image-tool
 * Exporte la classe VisualImageTool
 */

import VisualImageTool from "./visual-image-tool.js";

// Exporter la classe comme export par défaut
export default VisualImageTool;

// Exporter également comme export nommé pour plus de flexibilité
export { VisualImageTool };
